// Permission values (binary)
export const PERMISSIONS = {
  NONE: 0,      // 0000
  READ: 1,      // 0001
  CREATE: 2,    // 0010
  UPDATE: 4,    // 0100
  DELETE: 8,    // 1000
  ALL: 15       // 1111
}

// Feature to route mapping
export const FEATURE_ROUTES = {
  user: ['/users', '/users/create', '/users/edit'],
  role: ['/roles', '/roles/create', '/roles/edit'],
  sensortype: ['/sensor-types', '/sensor-types/create', '/sensor-types/edit'],
  sensor: ['/sensors', '/sensors/create', '/sensors/edit'],
  client: ['/client-registration', '/client-management'],
}

// Check if user has required permission for a feature
export const hasPermission = (permissions, feature, requiredPermission = PERMISSIONS.READ) => {
  if (!permissions || !feature || !permissions.hasOwnProperty(feature)) {
    return false;
  }

  const featurePermission = permissions[feature];

  if (featurePermission === PERMISSIONS.ALL) return true;

  // Special handling for user and role features
  if (feature === 'user' || feature === 'role') {
    const hasRead = (featurePermission & PERMISSIONS.READ) === PERMISSIONS.READ;
    const hasOther = (featurePermission & (PERMISSIONS.CREATE | PERMISSIONS.UPDATE | PERMISSIONS.DELETE)) !== 0;
    return hasRead && hasOther;
  }

  return (featurePermission & requiredPermission) === requiredPermission;
}

// Check if user has access to a specific route
export const hasRouteAccess = (permissions, path) => {
  // Allow access to predefined public routes
  const publicRoutes = ['/', '/ais-monitoring', '/cctv', '/vessel-lists'];
  if (publicRoutes.includes(path)) return true;

  for (const [feature, routes] of Object.entries(FEATURE_ROUTES)) {
    if (routes.some(route => path.startsWith(route))) {
      // Special handling for user and role features
      if (feature === 'user' || feature === 'role') {
        const featurePermission = permissions[feature];
        const hasRead = (featurePermission & PERMISSIONS.READ) === PERMISSIONS.READ;
        const hasOther = (featurePermission & (PERMISSIONS.CREATE | PERMISSIONS.UPDATE | PERMISSIONS.DELETE)) !== 0;
        return hasRead && hasOther;
      }

      // Regular permission checks for other features
      if (path.includes('/create')) {
        return hasPermission(permissions, feature, PERMISSIONS.CREATE);
      } 
      if (path.includes('/edit')) {
        return hasPermission(permissions, feature, PERMISSIONS.UPDATE);
      } 
      return hasPermission(permissions, feature, PERMISSIONS.READ);
    }
  }

  return false; // Deny access to undefined feature routes
} 
